<template>
  <div class="wrap">
    <div class="head">
      <img src="@/assets/new/lock_title.png" alt="">
    </div>
    <div class="lock">
      <div class="lock_icon">
        <img src="@/assets/new/lock_icon.png" alt="">
      </div>
      <div class="lock_cont">
        <div class="tip1">{{ $t('账户冻结') }}</div>
        <div class="tip2">{{ $t('联系贷款助理') }}</div>
        <div class="tip3">{{ $t('向系统确认解冻') }}</div>
        <div class="cont_info">
          <div class="info">
            <div class="info_title">{{ $t('账户信息') }}</div>
            <div class="info_item">
              <div class="label">{{ $t('名字') }}</div>
              <div class="value">{{ userInfo.auth_data && userInfo.auth_data.name }}</div>
            </div>
            <div class="info_item">
              <div class="label">{{ $t('login.phoneNumber') }}</div>
              <div class="value">{{ userInfo.userphone }}</div>
            </div>
            <div class="info_item">
              <div class="label">{{ $t('身份证') }}</div>
              <div class="value">{{ userInfo.auth_data && userInfo.auth_data.idcard }}</div>
            </div>
            <div class="info_item">
              <div class="label">{{ $t('address') }}</div>
              <div class="value">{{ userInfo.auth_data && userInfo.auth_data.address }}</div>
            </div>
            <div class="info_item">
              <div class="label">{{ $t('orderNo') }}</div>
              <div class="value">{{ userInfo.loan && userInfo.loan.loan_no }}</div>
            </div>
          </div>
        </div>
        <div class="info_input">
          <van-field v-model="code" label-width="0" :placeholder="$t('请具体说明')" />
        </div>
        <div class="info_btn" @click="submit" :style="code == '' ? { 'opacity': .6 } : {}">{{ $t('好的') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Field, Toast } from "vant";
import { USERS_UNLOCK } from "@/api"
export default {
  components: {
    [Field.name]: Field,
    Toast
  },
  data() {
    return {
      code: ''
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    async submit() {
      if (!this.code) return;
      Toast.loading();
      try {
        const res = await USERS_UNLOCK({ code: this.code });
        Toast(res.msg);
        setTimeout(()=>{
          this.$router.replace('goods');
        },1000)
      } catch (error) {
        Toast(error.msg)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .head {
    background: url('../../assets/new/lock_bg.png') no-repeat;
    background-size: cover;
    width: 100%;
    height: 25vh;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 80%;
      display: block;
    }
  }

  .lock {
    flex-grow: 1;
    background: linear-gradient(180deg, #edebec, #e5b8ba);
    margin-top: -30px;
    border-radius: 30px 30px 0 0;

    .lock_icon {
      padding: 20px 0 15px;
      display: flex;
      justify-content: center;

      img {
        width: 25%;
        display: block;
      }
    }

    .lock_cont {
      .tip1 {
        text-align: center;
        font-size: 24px;
        color: #791f1f;
        font-weight: bold;
        padding-bottom: 10px;
      }

      .tip2,
      .tip3 {
        text-align: center;
        color: #aa797a;
        font-size: 16px;
        padding-bottom: 8px;
      }

      .cont_info {
        padding: 20px 20px 0;

        .info {
          background: #e4cfcf;
          border-radius: 8px;
          padding: 20px;

          .info_title {
            width: fit-content;
            background: #cd2429;
            color: var(--white);
            font-size: 16px;
            padding: 10px 20px;
            border-radius: 10px;
            margin: -35px auto 20px;
          }

          .info_item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 8px;
            font-size: 14px;

            .label {
              color: #843e3e;
              font-weight: 700;
            }

            .value {
              color: #843e3e;
              opacity: .8;
            }
          }
        }
      }

      .info_input {
        padding: 15px 0 10px;
        display: flex;
        justify-content: center;

        /deep/ .van-cell {
          width: 60%;
          padding: 0 16px;
          line-height: 45px;
          border-radius: 8px;
        }
      }

      .info_btn {
        background: var(--btnColor);
        color: var(--white);
        width: 30%;
        margin: 0 auto 20px;
        height: 45px;
        line-height: 45px;
        text-align: center;
        font-size: 16px;
        border-radius: 8px;
        font-weight: 700;
      }
    }
  }
}
</style>